import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dkk', standalone: false })
export class DkkPipe implements PipeTransform {
    transform(value: number | string): string {
        const n = typeof value === 'string' ? parseFloat(value) : value;
        if (n === undefined || n === null || isNaN(n)) {
            return (0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' DKK';
        }
        return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' DKK';
    }
}
